import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import Auth from "../../services/Auth";
import FieldError from "../../components/ui/FieldError";
import { useState } from "react";
import { useNavigate } from "react-router";
import Base from "../base";
import LogoHead from "../../components/LogoHead";
import { useTranslation } from "react-i18next";

function Forgot() {
  const form = useForm();
  const [successMsg, setSuccessMsg] = useState();
  let navigate = useNavigate();
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    setSuccessMsg(null);
    try {
      let response = await Auth.forgot({ email: data.email });
      setSuccessMsg(response.data.message);
    } catch ({ response }) {
      if (response?.data) {
        form.setError("email", {
          type: "manual",
          message: response.status
            ? Object.values(response.data)[0]
            : response.data.message,
        });
      }
    }
  };

  return (
    <Base navbar={false}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex flex-col py-16 justify-center items-center">
          <LogoHead />
          <div className="mt-16 p-4 xl:flex lg:w-2/5">
            <div className="w-full px-6">
              <div className="text-2xl mb-4 text-bioport-blue font-bold">
                {t("login.password.forgot")}
              </div>
              {!successMsg ? (
                <>
                  <input
                    {...form.register("email")}
                    name="email"
                    type="text"
                    className="w-full"
                    placeholder={t("login.email")}
                  />
                  <FieldError error={form.formState?.errors?.email} />
                  <div className="flex items-center justify-end mt-4 pt-3">
                    <div>
                      <Button
                        className="btn btn-primary"
                        isloading={form.formState.isSubmitting}
                      >
                        {t("login.reset_pass")}
                      </Button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="text-center flex flex-col">
                  <div className="mb-6 mt-2 bg-green-100 px-6 py-3 border border-green-500 text-green-800 text-sm">
                    {successMsg}
                  </div>
                  <div
                    className="btn btn-primary cursor-pointer mt-3"
                    onClick={() => navigate("/", { replace: true })}
                  >
                    {t("login.back_login")}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    </Base>
  );
}

export default Forgot;
